import OfferGroupClicksTable from '../OfferGroupClicksTable';

type Props = {};

const OfferGroupClicks = (props: Props) => {
  return <OfferGroupClicksTable />;
};

export default OfferGroupClicks;
